import React from 'react';
import './QuickColorPicker.css';

const QuickColorPicker = ({ isOpen, onClose, onColorSelect, onOpenFullSettings, anchorElement }) => {
  // Well-balanced color palette
  const colors = [
    '#007cbf', // Default blue
    '#4CAF50', // Green
    '#F44336', // Red
    '#FF9800', // Orange
    '#9C27B0', // Purple
    '#2196F3', // Light blue
    '#795548', // Brown
    '#607D8B', // Blue gray
    '#E91E63', // Pink
    '#3F51B5', // Indigo
    '#009688', // Teal
    '#CDDC39', // Lime
    '#FFC107', // Amber
    '#FF5722', // Deep orange
    '#673AB7', // Deep purple
    '#000000', // Black
    '#666666', // Dark gray
    '#FFFFFF'  // White
  ];

  if (!isOpen || !anchorElement) return null;

  // Calculate position relative to the anchor element
  const rect = anchorElement.getBoundingClientRect();
  const style = {
    position: 'fixed',
    top: rect.bottom + 5,
    left: rect.left,
    zIndex: 1000
  };

  // Adjust position if it would go off screen
  if (rect.left + 240 > window.innerWidth) {
    style.left = window.innerWidth - 250;
  }
  if (rect.bottom + 200 > window.innerHeight) {
    style.top = rect.top - 200;
  }

  return (
    <>
      {/* Backdrop to close on outside click */}
      <div className="quick-color-picker-backdrop" onClick={onClose} />
      
      <div className="quick-color-picker" style={style}>
        <div className="quick-color-picker-header">
          <span>Quick Color</span>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        
        <div className="color-grid">
          {colors.map((color, index) => (
            <button
              key={index}
              className="color-swatch"
              style={{ 
                backgroundColor: color,
                border: color === '#FFFFFF' ? '1px solid #ddd' : 'none'
              }}
              onClick={() => onColorSelect(color)}
              title={color}
            />
          ))}
        </div>
        
        <div className="quick-color-picker-actions">
          <button 
            className="btn-full-settings"
            onClick={onOpenFullSettings}
          >
            More Options...
          </button>
        </div>
      </div>
    </>
  );
};

export default QuickColorPicker;